import { FaSquareGithub,FaLinkedin,FaSquareFacebook } from  "react-icons/fa6";
import { SiGmail } from "react-icons/si";
import { Link } from "react-router-dom";
function Footer({github,facebook}) {
let data = new Date();
    return(
     <footer>

        <h1>&copy; Yousif Ibrahim {data.getFullYear()} built with ReactJS</h1>
        
        <Link to="www.linkedin.com/in/yousif-ibrahim-23b27b313" target="_blank" ><FaLinkedin/></Link>
        <Link to="https://www.facebook.com/share/tU2ntm7uAjnRZJxW/?mibextid=qi2Omg" target="_blank" ><FaSquareFacebook/></Link>
        <Link to="https://github.com/249joe" target="_blank" ><FaSquareGithub/></Link>
        <Link to="https://mail.google.com" target="_blank" ><SiGmail/></Link>
        
     </footer>
    )
}
export default Footer;
